/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../../../utils/routes";
import Axios from "axios";
import { getAll, getById } from "../../../utils/requests/dynamicReq";
import { paths } from "../../../utils/paths";

import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Form, InputGroup } from "react-bootstrap";
import { useSelector } from "react-redux";
import { IStore } from "../../../interfaces/IStore";
import { IUser } from "../../../interfaces/IUser";

interface IEntidadFinanciadoraShort {
  id: string;
  nombre: string;
}

export const EntidadFinanciadora: FC = () => {
  const history = useHistory();

  let { staffId, isAdmin, userRoleId } = useSelector(
    ({ user }: IStore) => user as IUser
  );

  const [isLoading, setIsLoading] = useState(false);

  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();
  const { FINANCIADORAS, INVESTIGATORS } = paths;
  const [entidadesFinanciadoras, setEntidadesFinanciadoras] = useState<any>([]);
  const [search, setSearch] = useState("");
  const [filteredEntidadesFinanciadoras, setFilteredEntidadesFinanciadoras] =
    useState<IEntidadFinanciadoraShort[]>([]);

  useEffect(() => {
    setIsLoading(true);
    isMountedRef.current = true;
    try {
      isMountedRef.current && loadEntidadesFinanciadoras();
    } catch (error) {
      console.log(error);
      console.log("HTTP call cancelled");
    }
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
  }, []);

  const loadEntidadesFinanciadoras = async () => {
    try {
      if (isAdmin) {
        const response = await getAll(FINANCIADORAS, source);
        if (isMountedRef.current) {
          filterEntidadesFinanciadoras(response);
        }
      } else if (!isAdmin) {
        let id = staffId.toString();
        const investigator = await getById(INVESTIGATORS, id, source);
        if (isMountedRef.current) {
          filterEntidadFinanciadoraByInvestigator(investigator);
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const filterEntidadesFinanciadoras = (rawEntidadesFinanciadoras: any[]) => {
    let entidadesFinanciadoras: IEntidadFinanciadoraShort[] =
      rawEntidadesFinanciadoras.map(
        ({ id, nombre }: IEntidadFinanciadoraShort) => ({
          id,
          nombre,
        })
      );
    setEntidadesFinanciadoras(entidadesFinanciadoras);
    setFilteredEntidadesFinanciadoras(entidadesFinanciadoras);
  };

  const filterEntidadFinanciadoraByInvestigator = (
    rawEntidadesFinanciadoras: any
  ) => {
    if (!!rawEntidadesFinanciadoras.investigationGroup) {
      let entidadesFinanciadoras: IEntidadFinanciadoraShort[] = [
        {
          id: rawEntidadesFinanciadoras?.investigationGroup?.id,
          nombre: rawEntidadesFinanciadoras?.investigationGroup?.tituloEs,
        },
      ];
      setEntidadesFinanciadoras(entidadesFinanciadoras);
      setFilteredEntidadesFinanciadoras(entidadesFinanciadoras);
    }
  };

  const handleSearch = (value: any) => {
    setSearch(value);
    setFilteredEntidadesFinanciadoras(
      entidadesFinanciadoras.filter(({ nombre }: any) =>
        nombre.toLowerCase().includes(value.toLowerCase())
      )
    );
    !value && setFilteredEntidadesFinanciadoras(entidadesFinanciadoras);
  };

  return (
    <div className="container-fluid p-4">
      {!isAdmin && userRoleId !== 3 ? (
        <>Usted no tiene acceso</>
      ) : (
        <>
          {" "}
          <div className="row">
            <div className="col-12 d-flex justify-content-between">
              <h3>Entidades Financiadoras</h3>
              <div>
                {(isAdmin || userRoleId === 3) && (
                  <button
                    className="baseBtn"
                    onClick={() =>
                      history.push(`${ROUTES.EntidadesFinanciadoras.create}`)
                    }
                  >
                    + Añadir
                  </button>
                )}
              </div>
            </div>
          </div>
          {/* <div className="center flex-column justify-content-around text-center p-5 mt-2"> */}
          <div className="row mt-4">
            <Form.Group as={Col}>
              <InputGroup className="shadow">
                <InputGroup.Prepend>
                  <InputGroup.Text className="inputGroup ">
                    <FontAwesomeIcon color="#0073B5" icon={faSearch} />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="text"
                  placeholder="Buscar..."
                  className="form-control"
                  value={search}
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </InputGroup>
            </Form.Group>
          </div>
          <div className="row">
            <div className="col-12 ">
              <table className="table table-hover">
                <tbody>
                  {filteredEntidadesFinanciadoras?.map(
                    (
                      { id, nombre }: IEntidadFinanciadoraShort,
                      index: number
                    ) => (
                      <tr
                        key={index}
                        className="pointer"
                        onClick={() =>
                          history.push(
                            `${ROUTES.EntidadesFinanciadoras.all}/${id}`
                          )
                        }
                      >
                        <td>{`${nombre}`}</td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
              {isLoading && (
                <div className="d-flex justify-content-center">
                  <div className="spinner-border mt-5" role="status" />
                </div>
              )}

              {!filteredEntidadesFinanciadoras.length &&
                !isLoading &&
                isAdmin && (
                  <div className="d-flex justify-content-center mb-3">
                    <h5>-No existen entidades-</h5>
                  </div>
                )}

              {!filteredEntidadesFinanciadoras.length &&
                !isLoading &&
                !isAdmin && (
                  <div className="d-flex justify-content-center mb-3">
                    <h5>-No pertenece a ningúna entidad-</h5>
                  </div>
                )}
            </div>
          </div>
        </>
      )}
    </div>
    // </div>
  );
};
